var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F7F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18092 12.8657L15.8103 17.9752C15.8276 17.9887 15.8484 17.997 15.8704 17.9993C15.8923 18.0017 15.9144 17.9978 15.9342 17.9883C15.954 17.9787 15.9707 17.9639 15.9824 17.9454C15.994 17.9269 16.0001 17.9056 16 17.8838V16.7621C16 16.691 15.9662 16.6228 15.9103 16.5792L10.6162 12.5001L15.9103 8.4209C15.9676 8.37737 16 8.30916 16 8.23806V7.11633C16 7.0191 15.8868 6.96541 15.8103 7.0249L9.18092 12.1344C9.12458 12.1777 9.079 12.2332 9.04765 12.2966C9.0163 12.36 9 12.4295 9 12.5001C9 12.5706 9.0163 12.6402 9.04765 12.7035C9.079 12.7669 9.12458 12.8224 9.18092 12.8657Z",
    fill: "#4A4A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.d73db74fc5e75a6a15d63f042593d4d4.svg";
export { ForwardRef as ReactComponent };